export default __webpack_public_path__ + "static/media/disFair.06717d64.svg";